var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSanMarino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.95441 40 3.05176e-05 31.0457 3.05176e-05 20C0.869562 20 20 17.3914 20 17.3914L40 20Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000289917 20.0001C0.000289917 8.95444 8.95466 6.10352e-05 20.0003 6.10352e-05C31.0459 6.10352e-05 40.0003 8.95444 40.0003 20.0001",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9388 13.8004L20.0001 21.7392L12.0613 13.8004C11.0347 15.3243 10.4349 17.1586 10.4349 19.1304V21.7391C10.4349 25.9279 13.1416 29.4961 16.8976 30.7875C16.3963 31.77 16.4808 32.9962 17.2154 33.913C18.191 33.1311 19.2011 32.3216 20.058 31.635C20.9149 32.3217 21.925 33.1311 22.9006 33.913C23.6438 32.9855 23.7222 31.741 23.2011 30.7527C26.9058 29.4332 29.5652 25.8911 29.5652 21.7391V19.1305C29.5653 17.1586 28.9655 15.3244 27.9388 13.8004V13.8004Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 28.6956C16.1641 28.6956 13.0435 25.5749 13.0435 21.7392V19.1305C13.0435 15.2946 16.1642 12.174 20 12.174C23.8358 12.174 26.9565 15.2947 26.9565 19.1305V21.7392C26.9565 25.5749 23.8359 28.6956 20 28.6956Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3477 21.7391V19.1305C24.3477 16.733 22.3973 14.7827 19.9999 14.7827C17.6026 14.7827 15.6521 16.7331 15.6521 19.1305V21.7391L19.9999 22.6087L24.3477 21.7391Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6521 21.7391C15.6521 24.1366 17.6026 26.0869 19.9999 26.0869C22.3973 26.0869 24.3477 24.1365 24.3477 21.7391H15.6521Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2175 12.1739C25.2175 10.7332 24.0496 9.56526 22.6089 9.56526C21.9405 9.56526 21.3314 9.81682 20.8697 10.23V8.69565H21.7392V6.95651H20.8697V6.08698H19.1306V6.95651H18.261V8.69565H19.1306V10.23C18.6689 9.81682 18.0597 9.56526 17.3914 9.56526C15.9507 9.56526 14.7828 10.7332 14.7828 12.1739C14.7828 12.9463 15.1188 13.6401 15.6523 14.1178V15.6522H24.3479V14.1178C24.8815 13.6401 25.2175 12.9463 25.2175 12.1739V12.1739Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanMarino);
export default __webpack_public_path__ + "static/media/san_marino.9698197379cb6d4673763876e7ed3b72.svg";
export { ForwardRef as ReactComponent };